module.exports = __webpack_public_path__ + "img/B45A0869.b5f40a6a.jpg";